export const css = {
	root: '_2VpnSM3Z',
	input: '_1DezBAin',
	inputWrapper: 'VUEgKn-D _3TChflmG _1fXJU5m6',
	checked: '_3EG0DoaF',
	focused: 'VfGnnKmq',
	onLabel: '_2ACWMWzK',
	offLabel: '_2REbq3uC',
	disabled: '_2HrA0iHF',
	readonly: '_2VmlRT6W',
	invalid: 'LQ1tk8zI',
	valid: '_2tOU7n84',
	' _key': 'ascm-theme/ascm/dojo/checkbox'
};

export default css;
